module.exports = __webpack_public_path__ + "img/profile.38acc2f1.svg";